// import { __ } from '@wordpress/i18n';
import { store, getContext, getElement, getConfig } from '@wordpress/interactivity';

(function ($) {

    /**
  * Caleran / scripts tiers peuvent appeler moment().middleOfDay().
  * Cette méthode n'existe pas dans Moment "vanilla", donc on la polyfill.
  */
    function ensureMomentMiddleOfDay() {
        if (typeof window.moment !== 'function') return;
        if (!window.moment.fn) return;
        if (typeof window.moment.fn.middleOfDay === 'function') return;

        // Moment est mutable: on reste cohérent avec ses méthodes chainables.
        window.moment.fn.middleOfDay = function () {
            return this.startOf('day').add(12, 'hours');
        };
    }

    // Si Moment est déjà présent (chargé par WP ou un autre plugin), on polyfill tout de suite.
    ensureMomentMiddleOfDay();

    if (document.querySelectorAll('.gt-widgets-ctv-resa').length == 0) return;

    function loadScript(url, callback) {
        const script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.async = true;
        script.onload = callback;
        document.head.appendChild(script);
    }

    function loadStyle(url) {
        const link = document.createElement('link');
        link.href = url;
        link.type = 'text/css';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
    }

    loadScript(gtFseCtvVars.pluginUrl + '/lib/jscookies/js.cookies.min.js');
    loadScript(gtFseCtvVars.pluginUrl + '/lib/caleran/vendor/moment.min.js', function () {
        ensureMomentMiddleOfDay();
        loadScript(gtFseCtvVars.pluginUrl + '/lib/caleran/js/caleran.min.js');
    });
    loadStyle(gtFseCtvVars.pluginUrl + '/lib/caleran/css/caleran.min.css');

    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.gt-widgets-ctv-resa__toggle').addClass('open');
        } else {
            $('.gt-widgets-ctv-resa__toggle').removeClass('open');
        }
    });

    $(document).on('click', '.gt-widgets-ctv-resa__toggle', function () {
        $(this).parent().addClass('gt-widgets-ctv-resa--open');
    });

    $(document).on('click', '.gt-widgets-ctv-resa__hide', function () {
        $(this).parent().removeClass('gt-widgets-ctv-resa--open');
    });

    $(window).on('load', function () {

        ensureMomentMiddleOfDay();

        let language = 'fr';
        if (jQuery('html').attr('lang')) {
            language = jQuery('html').attr('lang').slice(0, 2);
        }

        const gtOptions = store('gt/options');

        var opening = (gtOptions && gtOptions.state && gtOptions.state.opening_date)
            ? moment(gtOptions.state.opening_date)
            : moment();
        var closing = (gtOptions && gtOptions.state && gtOptions.state.closing_date)
            ? moment(gtOptions.state.closing_date)
            : null;

        // Définir les dates d'arrivée et de départ initiales
        let arrival = Cookies.get('gt-arrival')
            ? moment(Cookies.get('gt-arrival'))
            : (moment() > opening ? moment() : opening);
        let departure = Cookies.get('gt-departure')
            ? moment(Cookies.get('gt-departure'))
            : moment(arrival).add(7, 'days');

        $('.gt-widgets-ctv-resa__form__entry--ranges').each(function () {

            ensureMomentMiddleOfDay();

            // Récupérer le conteneur de ce bloc, qui correspond au formulaire (sticky ou non)
            let $container = $(this).closest('.gt-widgets-ctv-resa');
            // Vous pouvez tester s'il s'agit du sticky via :
            let isSticky = $container.hasClass('sticky');

            let rawValue = $(this).attr('data-useTwoDateInputs') || "false";

            const useTwoDateInputs = rawValue.trim().toLowerCase() === "true";

            if (useTwoDateInputs) {
                let startDate, endDate;
                let startInstance, endInstance;

                const fillInputs = function () {
                    if (startInstance && startDate) {
                        startInstance.$elem.val(startDate.format(startInstance.config.format));
                    }
                    if (endInstance && endDate) {
                        endInstance.$elem.val(endDate.format(endInstance.config.format));
                    }
                };

                $container.find('input[name="arrival_date"]').caleran({
                    format: 'DD/MM/YYYY',
                    locale: language,
                    showHeader: false,
                    showFooter: false,
                    startDate: arrival,
                    // endDate: departure,
                    autoCloseOnSelect: true,
                    minDate: opening,
                    maxDate: closing,
                    calendarCount: 1,
                    cancelLabel: "Annuler",
                    applyLabel: "Appliquer",
                    oninit: function (instance) {
                        startInstance = instance;
                        if (!instance.config.startEmpty && instance.config.startDate) {
                            instance.$elem.val(instance.config.startDate.locale(instance.config.format).format(instance.config.format));
                            startDate = instance.config.startDate.clone();
                            Cookies.set('gt-arrival', startDate.format('YYYY-MM-DD'), { expires: inTwoHours() });
                        }
                    },
                    onbeforeshow: function (instance) {
                        if (startDate) {
                            startInstance.config.startDate = startDate;
                            endInstance.config.startDate = startDate;
                        }
                        if (endDate) {
                            startInstance.config.endDate = endDate.clone();
                            endInstance.config.endDate = endDate.clone();
                        }
                        fillInputs();
                        instance.updateHeader();
                        instance.reDrawCells();
                    },
                    onfirstselect: function (instance, start) {
                        startDate = start.clone();
                        startInstance.globals.startSelected = false;
                        startInstance.hideDropdown();
                        endInstance.showDropdown();
                        endInstance.config.minDate = startDate.clone();
                        endInstance.config.startDate = startDate.clone();
                        endInstance.config.endDate = null;
                        endInstance.globals.startSelected = true;
                        endInstance.globals.endSelected = false;
                        endInstance.globals.firstValueSelected = true;
                        endInstance.setDisplayDate(start);
                        if (endDate && startDate.isAfter(endDate)) {
                            endInstance.globals.endDate = endDate.clone();
                        }
                        endInstance.updateHeader();
                        endInstance.reDrawCells();
                        fillInputs();
                    }
                }).data('caleran');

                $container.find('input[name="departure_date"]').caleran({
                    format: 'DD/MM/YYYY',
                    locale: language,
                    showHeader: false,
                    showFooter: false,
                    // startDate: departure,
                    endDate: departure,
                    autoCloseOnSelect: true,
                    minDate: arrival,
                    maxDate: closing,
                    calendarCount: 1,
                    cancelLabel: "Annuler",
                    applyLabel: "Appliquer",
                    oninit: function (instance) {
                        endInstance = instance;
                        if (!instance.config.startEmpty && instance.config.endDate) {
                            instance.$elem.val(instance.config.endDate.locale(instance.config.format).format(instance.config.format));
                            endDate = instance.config.endDate.clone();
                            Cookies.set('gt-arrival', endDate.format('YYYY-MM-DD'), { expires: inTwoHours() });
                        }

                    },
                    onbeforeshow: function (instance) {
                        if (startDate) {
                            startInstance.config.startDate = startDate;
                            endInstance.config.startDate = startDate;
                        }
                        if (endDate) {
                            startInstance.config.endDate = endDate.clone();
                            endInstance.config.endDate = endDate.clone();
                        }
                        fillInputs();
                        instance.updateHeader();
                        instance.reDrawCells();
                    },
                    onafterselect: function (instance, start, end) {
                        startDate = start.clone();
                        endDate = end.clone();
                        endInstance.hideDropdown();
                        Cookies.set('gt-departure', endDate.format('YYYY-MM-DD'), { expires: inTwoHours() });
                        $('input[name="departure_date"]').val(endDate.format('DD/MM/YYYY'));

                        startInstance.config.endDate = endDate.clone();
                        startInstance.globals.firstValueSelected = true;
                        fillInputs();
                        endInstance.globals.startSelected = true;
                        endInstance.globals.endSelected = false;
                    }
                }).data('caleran');

            } else {

                $container.find('input').caleran({
                    format: 'DD/MM/YYYY',
                    locale: language,
                    showFooter: false,
                    startDate: arrival,
                    endDate: departure,
                    autoCloseOnSelect: true,
                    minDate: opening,
                    maxDate: closing,
                    calendarCount: $(window).width() < 768 ? 1 : 2,
                    cancelLabel: "Annuler",
                    applyLabel: "Appliquer",
                    oninit: function (caleran) {
                        let arrival = moment(caleran.config.startDate).format('YYYY-MM-DD');
                        Cookies.set('gt-arrival', arrival, { expires: inTwoHours() });
                        let departure = moment(caleran.config.endDate).format('YYYY-MM-DD');
                        Cookies.set('gt-departure', departure, { expires: inTwoHours() });
                    },
                    onafterselect: function (caleran, startDate, endDate) {
                        let arrival = moment(startDate).format('YYYY-MM-DD');
                        Cookies.set('gt-arrival', arrival, { expires: inTwoHours() });
                        let departure = moment(endDate).format('YYYY-MM-DD');
                        Cookies.set('gt-departure', departure, { expires: inTwoHours() });
                        $('.gt-dispo-loaded').removeClass('gt-dispo-loaded');

                        $('.gt-widgets-ctv-resa-form__entry--ranges input').each(function () {
                            let instance = $(this).data('caleran');
                            instance.setStart(startDate);
                            instance.setEnd(endDate);
                        });
                    }
                });
            }
        });
    });




    $('.gt-widgets-ctv-resa:not(.sticky) input[name="arrival_date"], .gt-widgets-ctv-resa:not(.sticky) input[name="departure_date"]').on('focus click', function () {
        $('.gt-widgets-ctv-resa.sticky input').each(function () {
            let inst = $(this).data('caleran');
            if (inst) {
                inst.hideDropdown();
            }
        });
    });

    // Et vice versa pour le formulaire sticky
    $('.gt-widgets-ctv-resa.sticky input[name="arrival_date"], .gt-widgets-ctv-resa.sticky input[name="departure_date"]').on('focus click', function () {
        $('.gt-widgets-ctv-resa:not(.sticky) input').each(function () {
            let inst = $(this).data('caleran');
            if (inst) {
                inst.hideDropdown();
            }
        });
    });

    function inTwoHours() {
        let time = new Date();
        time.setHours(time.getHours() + 2);
        return time;
    }

    $(document).on('submit', '.gt-widgets-ctv-resa__form', function (e) {
        e.preventDefault();
    });

    // Fonction pour gérer la soumission du formulaire
    function handleFormSubmit($submitElement) {
        // Récupérer le formulaire parent
        let $form = $submitElement.closest('.gt-widgets-ctv-resa__form');
        let dateStart, dateEnd;

        // Si ce formulaire contient deux inputs séparés (on vérifie via la classe inputs-multiple)
        if ($form.find('.gt-widgets-ctv-resa__form__entry--ranges.inputs-multiple').length > 0) {
            dateStart = $form.find('input[name="arrival_date"]').val();
            dateEnd = $form.find('input[name="departure_date"]').val();
        } else {
            // Si c'est un seul input pour la plage, récupérer la valeur et la scinder
            let rangeVal = $form.find('.gt-widgets-ctv-resa__form__entry--ranges input').val();
            if (rangeVal) {
                let ranges = rangeVal.split(' - ');
                dateStart = ranges[0];
                dateEnd = ranges[1];
            }
        }

        // Vérifier s'il y a un camping sélectionné avec une URL
        let $campingSelect = $form.find('select[name="camping"]');
        let selectedCamping = $campingSelect.find('option:selected');
        let campingUrl = selectedCamping.data('url');

        // Si un camping avec une URL est sélectionné, rediriger vers cette URL
        if (campingUrl && campingUrl.trim() !== '') {
            // Construire l'URL avec les paramètres de recherche
            let urlParams = new URLSearchParams();
            if (dateStart) urlParams.append('arrival', dateStart);
            if (dateEnd) urlParams.append('departure', dateEnd);

            let travelers = $form.find('.gt-widgets-ctv-resa__form__entry--personnes select').val();
            if (travelers) urlParams.append('travelers', travelers);

            let productType = $form.find('.gt-widgets-ctv-resa__form__entry--type select').val();
            if (productType) urlParams.append('productType', productType);

            // Ajouter les paramètres à l'URL du camping
            let finalUrl = campingUrl;
            if (urlParams.toString()) {
                finalUrl += (campingUrl.includes('?') ? '&' : '?') + urlParams.toString();
            }

            // Rediriger vers l'URL du camping
            window.location.href = finalUrl;
            return;
        }

        // Sinon, utiliser le comportement par défaut (événement CTV)
        let params = {
            dateStart: dateStart,
            dateEnd: dateEnd,
            travelers: $form.find('.gt-widgets-ctv-resa__form__entry--personnes select').val(),
            productType: $form.find('.gt-widgets-ctv-resa__form__entry--type select').val(),
        };

        window.dispatchEvent(new CustomEvent('ctv-widget.open-search', { detail: params }));
    }

    // Clic sur toute la div de soumission (y compris le bouton et les images)
    $(document).on('click', '.gt-widgets-ctv-resa__form__entry--submit', function (e) {
        // Empêcher le comportement par défaut du bouton si le clic vient directement du bouton
        if ($(e.target).is('button') || $(e.target).closest('button').length > 0) {
            e.preventDefault();
        }

        handleFormSubmit($(this));
    });

})(jQuery);